'use client';

import { Star } from "@/components/private/star";
import { modalShow } from "@/components/private/actions/modal";

export default function VideoRatingLocked({ current, className, }: { current: number, className: string }) {
  return (
    <div title={`rating: ${current}`} className={className} onClick={() => modalShow(`locked`)} style={{ cursor: `pointer`, }}>
      <Star className={`rating-star rating-star-0 ${current > 0 ? `active` : ``}`} />
      <Star className={`rating-star rating-star-1 ${current > 1 ? `active` : ``}`} />
      <Star className={`rating-star rating-star-2 ${current > 2 ? `active` : ``}`} />
      <Star className={`rating-star rating-star-3 ${current > 3 ? `active` : ``}`} />
      <Star className={`rating-star rating-star-4 ${current > 4 ? `active` : ``}`} />
    </div>
  );
}
